export const getBrandConfig = (brandConfig) => {
	return brandConfig?.id
		? {
        brand: {
          id: brandConfig?.id,
          themeName: brandConfig?.themeName
        }
		  }
		: {};
};
